import { createMarkup } from 'app/utils';
import { Flex, Typography } from 'components';
import { useContents } from 'features/contents';
import { DownloadsBoxContent } from 'features/downloads';
import { useFullscreen } from 'features/fullscreen';
import React, { ReactElement } from 'react';
import styled from 'styled-components';

const ElementWrapper = styled('div')`
  ${(props: any) => {
    return `
      width: 100vw;
      height: 400px;

      ${props.theme.mediaQueries.desktop} {
        width: 425px;
        height: ${
          props['data-hastabs']
            ? props['data-fullscreen']
              ? 'calc(100vh - 141px)'
              : '645px'
            : props['data-fullscreen']
            ? 'calc(100vh - 81px)'
            : '705px'
        };
      }
    `;
  }}
`;

const ScrollableWrapper = styled('div')`
  width: 100%;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

interface SideDetailsProps {
  hasTabs: boolean;
}

const SideDetails = ({ hasTabs }: SideDetailsProps): ReactElement => {
  const { contentDetails } = useContents();
  const [isFullscreen] = useFullscreen();

  return (
    <ElementWrapper data-fullscreen={isFullscreen} data-hastabs={hasTabs}>
      <ScrollableWrapper>
        <Flex p={{ m: 20, d: 30 }} flexDirection="column">
          <Typography type="type3" color="color50" lineHeight="1.3">
            <div dangerouslySetInnerHTML={createMarkup(contentDetails?.productClassTimelineName)} />
          </Typography>

          <Typography type="type6" fontWeight="bold" color="color100" lineHeight="1.3">
            <div dangerouslySetInnerHTML={createMarkup(contentDetails.name)} />
          </Typography>

          {Boolean(contentDetails?.teacher) && (
            <Typography type="type3" color="color80" lineHeight="1.3" mt={{ m: 2, d: 3 }}>
              Por: {contentDetails?.teacher?.name}
            </Typography>
          )}

          <Typography type="type2" color="color80" lineHeight="1.5" mt={{ m: 3, d: 4 }}>
            <div dangerouslySetInnerHTML={createMarkup(contentDetails.description)} />
          </Typography>

          {Boolean(contentDetails && contentDetails.downloads.length) && (
            <Flex mt={{ m: 3, d: 6 }}>
              <DownloadsBoxContent downloads={contentDetails.downloads} />
            </Flex>
          )}
        </Flex>
      </ScrollableWrapper>
    </ElementWrapper>
  );
};
export default SideDetails;
